import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

import { ds } from '@/components/lib/design.system';

const SvgComponent = props => (
    <Svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" {...props}>
        <Path
            stroke={props.color ?? ds.colorValue.icon.primary}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="m4 8.558 2.87 3.135 5.103-7.383"
        />
    </Svg>
);
export default SvgComponent;
